import { Button } from "@nextui-org/react";
import { Helmet } from 'react-helmet';
import { toDataURL } from 'qrcode';
import {
    ShareIcon6White
} from "../images/svgs";

export const downloadQRCode = async (text, fileName) => {
    try {
        const dataUrl = await toDataURL(text, { width: 512 });
    
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = fileName;
        link.click();
    } catch (err) {

    }
}

export const getCurrentDate = (separator='-') => {
    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date<10?`0${date}`:`${date}`}`
}

export const HelmetWrapper = ({ title, description, url }) => {
    const canonicalUrl = url 
        ? `https://www.judgeautos.com/${url}/` 
        : "https://www.judgeautos.com/";

    const suffix = "| JudgeAutos"
    const metaTitle = title ? `${title} ${suffix}` : `Car Show Judging & Registration App ${suffix}`;
    const metaDescription = description || "JudgeAutos is an event management app for car, auto, jeep, and motorcycle shows with registration, real-time judging, scoring, and instant results.";
    
    return (
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
            
            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:type" content="website" />

            {/* Other Meta Tags */}
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
        </Helmet>
    )
}

export const textToClipboard = async (text) => {
    if (typeof window === "undefined") return false;

    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
        
        const el = document.createElement("textarea");
        el.value = text;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        return true;
    } catch {
        return false;
    }
}

export const HandleWebShare = ({ title, text, url }) => {
    const fallbackShare = async () => {
        try {
            await navigator.clipboard.writeText(url || window.location.href);
            alert("Link copied to clipboard");
        } catch {
            const shareUrl = encodeURIComponent(url || window.location.href);
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,"_blank");
        }
    };
    
    if (navigator?.share && window.isSecureContext) {
        navigator.share({
            title: title || "Check this out!",
            text: text || "",
            url: url || window.location.href,
        })
    } else {
        fallbackShare();
    }
}